import React from 'react';
import { Dropdown } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconUserGroup } from '@bynder/icons';
import { dispatchCustomEvent } from '../../helpers/useCustomEvent';

export function WFGroupsMenuItem() {
	const { translate } = useTranslate();

	function openModal() {
		dispatchCustomEvent('openWFGroupsModal');
	}

	return (
		<Dropdown.Item
			onClick={openModal}
			icon={<IconUserGroup />}
			data-testid="wf-group-management-menuitem"
		>
			{translate('workflow.GroupManagement')}
		</Dropdown.Item>
	);
}
